import React from 'react';

import { ReactComponent as GoogleIcon } from '../../assets/icons/devicon_google.svg';
import { ReactComponent as LinkedinIcon } from '../../assets/icons/skill-icons_linkedin.svg';
import { ReactComponent as XIcon } from '../../assets/icons/x.com.svg';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/mingcute_arrow-up-line.svg';
import { ReactComponent as UploadIcon } from '../../assets/icons/material-symbols_upload.svg';

import { ReactComponent as PositionIcon } from '../../assets/icons/position.svg';
import { ReactComponent as TablerIcon } from '../../assets/icons/tabler_share.svg';
import { ReactComponent as editIcon } from '../../assets/icons/tabler_pencil.svg';
import { ReactComponent as WriteIcon } from '../../assets/icons/material-symbols_post-add-rounded.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/iconamoon_search-bold.svg';
import { ReactComponent as SearchLIghtIcon } from '../../assets/icons/iconamoon_search-light.svg';
import { ReactComponent as ShareIcon } from '../../assets/icons/tabler_share.svg';
import { ReactComponent as TrashIcon } from '../../assets/icons/iconamoon_trash-bold.svg';
import { ReactComponent as SignoutIcon } from '../../assets/icons/uil_signout.svg';
import { ReactComponent as BackArrowIcon } from '../../assets/icons/weui_arrow-filled.svg';
import { ReactComponent as FitIcon } from '../../assets/icons/fluent-mdl2_fit-page.svg';
import { ReactComponent as StructureIcon } from '../../assets/icons/solar_structure-bold.svg';
import { ReactComponent as checkIcon } from '../../assets/icons/circlular-check.svg';

// sidebar nav icons
import { ReactComponent as LibraryIcon } from '../../assets/icons/tabler_library.svg';
import { ReactComponent as AssetIcon } from '../../assets/icons/line-md_pencil.svg';
import { ReactComponent as CalenderIcon } from '../../assets/icons/mingcute_calendar-line.svg';
import { ReactComponent as ListIcon } from '../../assets/icons/gg_list.svg';
import { ReactComponent as SettingIcon } from '../../assets/icons/mdi_settings-outline.svg';

// training page icons

import { ReactComponent as GoogleCalendarIcon } from '../../assets/icons/google-calendar.svg';
import { ReactComponent as YoutubeIcon } from '../../assets/icons/youtube.svg';
import { ReactComponent as CalendlyIcon } from '../../assets/icons/calendly.svg';

export const icons = {
  google: GoogleIcon,
  linkedin: LinkedinIcon,
  x: XIcon,
  rightArrow: RightArrowIcon,
  upload: UploadIcon,
  position: PositionIcon,
  tabler: TablerIcon,
  pencil: editIcon,
  write: WriteIcon,
  search: SearchIcon,
  searchLight: SearchLIghtIcon,
  share: ShareIcon,
  trash: TrashIcon,
  signout: SignoutIcon,
  backArrow: BackArrowIcon,
  library: LibraryIcon,
  asset: AssetIcon,
  calender: CalenderIcon,
  list: ListIcon,
  setting: SettingIcon,
  fit: FitIcon,
  structure: StructureIcon,
  check: checkIcon,
  google_calendar: GoogleCalendarIcon,
  youtube: YoutubeIcon,
  calendly: CalendlyIcon,
};

export type IconType = keyof typeof icons;

interface IconProps {
  type: IconType;
  className?: string;
}

export const Icon: React.FC<IconProps> = ({ type, className }) => {
  const IconComponent = icons[type];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent className={className} />;
};
